export const PLAN_LIMITS = {
  free:    { catalogs_per_month: 0,        max_pages: 0    },
  starter: { catalogs_per_month: 5,        max_pages: 500  },
  growth:  { catalogs_per_month: 15,       max_pages: 500  },
  pro:     { catalogs_per_month: 50,       max_pages: 1500 }
};

export const PLAN_PRICES = {
  starter: { monthly: 49, annual: null, label: 'Starter' },
  growth:  { monthly: 99, annual: 990,  label: 'Growth' },
  pro:     { monthly: 199, annual: null, label: 'Pro' }
};
